/* eslint-disable */
/// @ts-nocheck -- Bulk rename to enable TypeScript validation

/* import '@mod-publisher/js/richcontent/all';
*/
require('./styling.css');
require('./video');
